import axiosInstance from 'services/api/config/api';
import type {
    GetAccessManagerDataResponse,
    CreateTenantRequest,
    Tenant,
    CreateUserRequest,
    UpdateUserRequest,
    User,
    DeleteResponse,
    ActiveAccount,
    OutboundTrunkInfo,
} from 'types/accessManager.type';

export const getAccessManagerData = (): Promise<GetAccessManagerDataResponse> => {
    return axiosInstance.get<GetAccessManagerDataResponse>('/access-manager').then((res) => res.data);
};

export const createTenant = (data: CreateTenantRequest): Promise<Tenant> => {
    return axiosInstance.post<Tenant>('/access-manager/tenant', data).then((res) => res.data);
};

export const getTenant = (id: string) => {
    return axiosInstance.get<Tenant['users']>(`/access-manager/tenant/${id}`).then((res) => res.data);
};

export const deleteTenant = (id: string): Promise<DeleteResponse> => {
    return axiosInstance.delete<DeleteResponse>(`/access-manager/tenant/${id}`).then((res) => res.data);
};

export const updateTenantStatus = (id: string): Promise<Tenant> => {
    return axiosInstance.put<Tenant>(`/access-manager/tenant/status/${id}`).then((res) => res.data);
};

export const createUser = (data: CreateUserRequest): Promise<User> => {
    return axiosInstance.post<User>('/access-manager/user', data).then((res) => res.data);
};

export const updateUser = (id: string, data: UpdateUserRequest): Promise<User> => {
    return axiosInstance.put<User>(`/access-manager/user/${id}`, data).then((res) => res.data);
};

export const deleteUser = (id: string): Promise<DeleteResponse> => {
    return axiosInstance.delete<DeleteResponse>(`/access-manager/user/${id}`).then((res) => res.data);
};

export const getActiveAccounts = (): Promise<ActiveAccount[]> => {
    return axiosInstance.get<ActiveAccount[]>('/access-manager/twilio/active-accounts').then((res) => res.data);
};

export const getOutboundTrunks = (): Promise<OutboundTrunkInfo[]> => {
    return axiosInstance.get<OutboundTrunkInfo[]>('/access-manager/livekit/outbound-trunks').then((res) => res.data);
};

const accessManagerService = {
    getAccessManagerData,
    createUser,
    updateUser,
    deleteUser,
    createTenant,
    getTenant,
    deleteTenant,
    updateTenantStatus,
    getActiveAccounts,
    getOutboundTrunks,
};

export default accessManagerService;
